import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, tap } from 'rxjs/operators';

import { isNumber, some } from 'lodash';
import { ImmunosuppressantService } from '@services/form/immunosuppressant.service';
import { CompaniesService } from '@app/companies/services/companies.service';
import { of } from 'rxjs';
import { PatientService } from '@services/patient';
import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class FormPatientNephroService {
    immunosuppressants;
    companies = [];
    careStaffs = [];
    specialists;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private immunosuppressantService: ImmunosuppressantService,
        private companiesService: CompaniesService,
        private patientService: PatientService,
    ) {}

    loadImmunosuppressants() {
        return this.immunosuppressantService.getImmunosuppressants().pipe(
            tap((immunosuppressants) => {
                this.immunosuppressants = immunosuppressants;
            }),
        );
    }

    initCompanies() {
        return this.companiesService
            .getSimpleCompanies('nephro')
            .pipe(tap((data) => (this.companies = data.companies)));
    }

    initSpecialistsFromPatient(patient) {
        return this.initSpecialistsFromCompanyId(
            patient,
            patient?.companyId?._id,
        );
    }

    initSpecialistsFromCompanyId(patient, companyId) {
        if (!companyId) return of([]);
        const params = { disease: 'nephro' };
        return this.companiesService
            .getReferentUsersFromCompany(companyId, params)
            .pipe(
                map((data) => {
                    this.specialists = data.usersCompany;
                    if (this.specialists.length === 1) {
                        this.patientService.selectSpecialist(
                            patient,
                            this.specialists[0],
                        );
                    }
                    return this.specialists;
                }),
            );
    }

    checkInclusionModePatient(patient) {
        return patient.specialistId;
    }

    checkIdentityPatient(patient) {
        return (
            patient.sex &&
            patient.lastName &&
            patient.firstName &&
            patient.birthDate &&
            patient.socialSecurityNumber
        );
    }

    checkContactPatient(patient) {
        return patient.phones.first || patient.phones.second;
    }

    checkMedicalDataPatient(patient) {
        return (
            (patient.medicalData.nephroType !== 'grafted' ||
                patient.medicalData.transplantDate) &&
            patient.medicalData.size
        );
    }

    checkMedicalData2Patient(patient) {
        return (
            patient.medicalData.idealDiastolic &&
            patient.medicalData.idealSystolic
        );
    }

    checkImmunosuppressantsPatient(patient) {
        const listTreatment = this.immunosuppressants?.map(({ key }) => key);

        return patient.treatmentImmunosuppressant?.some(
            ({ name, value, frequency, borne }) =>
                listTreatment.includes(name) &&
                isNumber(value) &&
                isNumber(frequency) &&
                isNumber(borne.min) &&
                isNumber(borne.max),
        );
    }

    checkOtherTreatmentsPatient() {
        return true;
    }

    checkCarestaffPatient(patient) {
        return patient.specialistId && patient.companyId;
    }

    checkAlgorithmDataPatient(patient) {
        return this.checkImmunosuppressantsPatient(patient);
    }

    checkMedicalDataReinclusionPatient(patient) {
        return some(patient.medicalData.significantEvent, (event) => !!event);
    }

    checkSettingsPatient(patient) {
        return patient.alertInterval;
    }

    checkBillingPatient(patient) {
        return (
            patient.cvDatas?.codeRegime &&
            patient.cvDatas?.centreGestionnaire &&
            patient.cvDatas?.caisseGestionnaire
        );
    }
}
